jQuery = require('jquery');

(function ($) {
  $.fn.limit_length = function () {
    function handle_event(ev) {
      var t = $(ev.currentTarget);
      update_warning(t);
    }

    function update_warning(t) {
      var l = t.val().length;
      var w = t.parent().find('span.warning');
      var limit = parseInt(t.attr('data-maxlen'));

      if (l > limit) {
        t.val(t.val().substr(0, limit));
      } else {
        w.html(limit - l);
      }
    }

    $(this).each(function (i, e) {
      $(e).after('<p class="note right"><span class="warning"></span> characters remaining.</p>');
      update_warning($(e));
      $(e).keyup(handle_event);
      $(e).change(handle_event);
    });
  };

  $.fn.closestDown = function (selector) {
    var selection = [];

    var query = function query() {
      this.children().each(function () {
        var $this = $(this);

        if ($this.is(selector)) {
          selection.push(this);
        } else {
          query.call($this);
        }
      });
    };

    query.call(this);
    return this.pushStack(selection, "closestDown", selector);
  };
})(jQuery);